import { Column16, List16 } from '@carbon/icons-react';
import { RadioChangeEvent, Tooltip } from 'antd';
import React, { FC, useCallback } from 'react';
import { useHistory, useLocation } from 'react-router';
import { Switcher } from 'components/atoms/switcher';
import { useTranslation } from 'hooks/use-translation';

interface ViewSwitcherProps {
  listUrl: string;
  boardUrl: string;
}

export const ViewSwitcher: FC<ViewSwitcherProps> = ({ listUrl, boardUrl }) => {
  const { pathname, search } = useLocation();
  const { push } = useHistory();
  const listViewName = useTranslation('list_view');
  const boardViewName = useTranslation('board_view');
  const onChange = useCallback(
    (e: RadioChangeEvent) => {
      if (e.target.value === pathname) {
        return;
      }

      push({
        pathname: e.target.value,
        search,
      });
    },
    [push, search, pathname],
  );

  return (
    <Switcher solid value={pathname} onChange={onChange} activeColor="black">
      <Tooltip title={listViewName} mouseEnterDelay={0.8}>
        <Switcher.Button id="switcher_list" value={listUrl} icon={<List16 />} />
      </Tooltip>
      <Tooltip title={boardViewName} mouseEnterDelay={0.8}>
        <Switcher.Button
          id="switcher_kanban"
          value={boardUrl}
          icon={<Column16 />}
        />
      </Tooltip>
    </Switcher>
  );
};
